import CoreApp from '../core/App';
export default CoreApp;